export default __webpack_public_path__ + "static/media/phone.d9be52ec.svg";